import { ComponentProps, memo } from 'react'
import { useFragment } from 'react-relay/hooks'
import { graphql } from 'relay-runtime'
import Suspense from 'components/Suspense'
import PersonAvatar from 'components/PersonAvatar'
import { UserAvatarContainer_User$key } from '__generated__/UserAvatarContainer_User.graphql'
import UserAvatar from './UserAvatar'

interface IUserAvatarContainerProps extends Omit<ComponentProps<typeof UserAvatar>, 'userId'> {
  userFragmentRef: UserAvatarContainer_User$key | null
  hideOnlineStatus?: boolean
}

function UserAvatarContainer({ userFragmentRef, ...restProps }: IUserAvatarContainerProps) {
  const user = useFragment(graphql`
    fragment UserAvatarContainer_User on User {
      id
    }
  `, userFragmentRef)

  const fallback = (
    <PersonAvatar
      {...restProps}
    />
  )

  if (!user) {
    return fallback
  }

  return (
    <Suspense fallback={fallback}>
      <UserAvatar
        userId={user.id}
        {...restProps}
      />
    </Suspense>
  )
}

export default memo(UserAvatarContainer)
